import React from 'react';
import { useTranslation } from 'react-i18next';

// Styled Components
import {
  Container,
  Column,
  ImagesList,
  SubContainer,
  BasicInfoColumns,
  RoadConditionColumns,
  StyledTypography,
  PersonDefinition,
} from './styles';

// Components
import { Definition } from '../Definition';

// Types
import { AccidentContentCardResumeProps } from './types';

// Hooks
import { useIsLandscapeTablet } from '../../../hooks/useMediaBreakPoints';
import { InputTextArea } from '../../inputs/InputTextArea';

export default function AccidentContentCardResume({
  creatorName,
  registeredByName,
  mediumKnowledge,
  laneCutting,
  policeReport,
  surveillanceBody,
  policeReportNumber,
  weather,
  surfaceCondition,
  luminosity,
  conditionsDriving,
  roadConditionDescription,
  images,
  ...props
}: AccidentContentCardResumeProps): JSX.Element {
  const { t } = useTranslation(['forms', 'tables']);
  const isLandscape = useIsLandscapeTablet();

  return (
    <Container {...props}>
      <SubContainer>
        <StyledTypography
          component="h3"
          size={isLandscape ? 'XS' : 'M'}
          variant="semiBold"
        >
          {t('accident.basicInfo')}
        </StyledTypography>
        <BasicInfoColumns>
          <Column>
            {/* Quién creó el registro y quién lo rellenó. La ficha (ShowOT)
                ya los enseñaba y este resumen no. Condicionales: en históricos
                sin operario no se pinta una fila vacía. Mismas etiquetas. */}
            {!!creatorName && (
              <PersonDefinition
                // La clave trae los dos puntos DENTRO del texto en los tres
                // idiomas ('Creado por:'), porque su consumidor original es la
                // etiqueta de un input, que no los añade. <Definition> sí los
                // añade → salía «Creado por::». Se los quitamos aquí en vez de
                // tocar los locales (son fuente de verdad de los E2E).
                title={t('forms:workOrder.createdBy').replace(/:\s*$/, '')}
                value={creatorName}
              />
            )}
            {!!registeredByName && (
              <PersonDefinition
                title={t('forms:registeredBy.label')}
                value={registeredByName}
              />
            )}
            <Definition
              title={t('accident.mediumKnowledge')}
              value={mediumKnowledge}
            />
            <Definition
              title={t('accident.laneCutting')}
              value={
                laneCutting ? t('common:labels.yes') : t('common:labels.no')
              }
            />
            <Definition
              title={t('accident.policeReport')}
              value={
                policeReport ? t('common:labels.yes') : t('common:labels.no')
              }
            />
            {policeReport && (
              <>
                <Definition
                  title={t('accident.surveillanceBody')}
                  value={surveillanceBody || ''}
                />
                <Definition
                  title={t('accident.policeReportNumber')}
                  value={policeReportNumber || ''}
                />
              </>
            )}
          </Column>
          <Column>
            <Definition title={t('tables:headers.multimedia')} value={''} />
            <ImagesList imageData={images} />
          </Column>
        </BasicInfoColumns>
      </SubContainer>
      <SubContainer>
        <StyledTypography
          component="h3"
          size={isLandscape ? 'XS' : 'M'}
          variant="semiBold"
        >
          {t('accident.roadCondition')}
        </StyledTypography>
        <RoadConditionColumns>
          <Column>
            <Definition title={t('accident.weather')} value={weather} />
            <Definition title={t('accident.luminosity')} value={luminosity} />
            <Definition
              title={t('accident.surface')}
              value={surfaceCondition}
            />
            <Definition
              title={t('accident.circulation')}
              value={conditionsDriving}
            />
          </Column>
          <Column>
            <InputTextArea
              label={t('accident.incidentDescription')}
              disabled
              value={roadConditionDescription}
            />
          </Column>
        </RoadConditionColumns>
      </SubContainer>
    </Container>
  );
}
